import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {MultiSelectModule} from 'primeng/multiselect';
import { FuseSharedModule } from '@fuse/shared.module';
import { OverzichtComponent } from './overzicht.component';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { AuthGuard } from 'app/core/services/auth.guard';
const routes = [
    {
        path     : 'medewerkers/overzicht',
        component: OverzichtComponent,
        canActivate: [AuthGuard],
        data: { roles: ['mws'] } 
    }
];

@NgModule({
    declarations: [
        OverzichtComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        MatCheckboxModule,
        MatTableModule,
        MatSortModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        TranslateModule,
        MatInputModule,
        FuseSharedModule,
        MultiSelectModule,
    ],
    exports     : [
        OverzichtComponent
    ]
})

export class OverzichtModule
{
}
